var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFace = function SvgFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22a9.7 9.7 0 0 1-3.875-.788 10.1 10.1 0 0 1-3.188-2.15 10.1 10.1 0 0 1-2.15-3.187A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10 10 0 0 1 2.15-3.175 10.3 10.3 0 0 1 3.187-2.137A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.875 10.3 10.3 0 0 1-2.137 3.188 10 10 0 0 1-3.175 2.15A9.7 9.7 0 0 1 12 22m-.001-18.5q-3.05 0-5.349 1.888-2.3 1.886-2.95 4.762 1.025 0 1.688-.488.662-.487 1.387-1.912a2.57 2.57 0 0 1 1.008-1.102A2.8 2.8 0 0 1 9.25 6.25h5.5q.803 0 1.467.398a2.57 2.57 0 0 1 1.008 1.102q.725 1.5 1.45 1.95t1.625.45q-.65-2.875-2.938-4.763Q15.076 3.501 12 3.5zm-.006 17q3.557 0 6.032-2.488T20.5 12v-.3q-1.9 0-2.938-.987a8.3 8.3 0 0 1-1.687-2.263 1.23 1.23 0 0 0-.468-.525 1.2 1.2 0 0 0-.632-.175H9.25q-.368 0-.659.175-.292.176-.466.525A7.9 7.9 0 0 1 6.4 10.738q-1.075.987-2.9.987V12q0 3.525 2.482 6.012Q8.463 20.5 11.993 20.5m-3.149-6.075a1.3 1.3 0 0 1-.956-.393 1.32 1.32 0 0 1-.388-.963q0-.57.393-.957t.963-.387c.57 0 .698.131.957.393q.387.393.387.963c0 .57-.131.698-.393.957a1.32 1.32 0 0 1-.963.387m6.325 0a1.3 1.3 0 0 1-.957-.393 1.32 1.32 0 0 1-.387-.963q0-.57.393-.957t.963-.387c.57 0 .698.131.957.393q.387.393.387.963c0 .57-.131.698-.393.957a1.32 1.32 0 0 1-.963.387"
  }))));
};
export default SvgFace;